module.exports = __webpack_public_path__ + "img/TradingView-icon15_th.678fd764.svg";